module.exports = __webpack_public_path__ + "img/township.d3bee8a0.jpg";